<template>
  <div>
    <h4 class="mb-3">{{ $t("transfering.method.text") }}</h4>

    <content-loading v-if="isLoading" />
    <empty v-if="!isLoading && (!pagination || pagination.docs.length == 0)" width="100px" />
    <div v-if="pagination">
      <b-card v-for="item in pagination.docs" no-body class="mb-1 border" :class="selectionMap[item._id] ? 'bg-soft-primary border-primary' : ''" :key="item._id">
        <b-card-body class="p-2 hand" @click="select(item)">
          <h6 class="mb-0">
            <i v-if="item.scope.value == 'workspace'" v-b-tooltip.hover :title="$t('workspace.yours')" class="text-muted mdi mdi-hexagon-multiple-outline"></i>
            <i v-else class="text-muted mdi mdi-database" v-b-tooltip.hover :title="$t('library.belonging-to-the-system')"></i>
            {{ item.name | translate }}
          </h6>
        </b-card-body>
      </b-card>

      <!-- Begin: Pagination -->

      <div class="row">
        <div class="col">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
          </ul>
        </div>
      </div>
      <!-- End: Pagination -->

      <sweet-button @click="ok()" :loading="isLoading" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-4">
        {{ $t("common.ok") }}
      </sweet-button>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      request: {
        options: { page: 1, limit: 20, sort: { name: "asc" } },
        query: {},
      },
    };
  },

  computed: {
    isLoading() {
      return this.$store.getters["method/isLoading"];
    },
    pagination() {
      return this.$store.getters["method/pagination"];
    },
    selectionMap() {
      const map = {};
      this.$store.getters["datasubjectTransfering/selectedMethods"]?.forEach((i) => (map[i._id] = i));

      return map;
    },
  },
  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.paginate();
      },
    },
  },
  mounted() {
    this.paginate();
  },
  methods: {
    paginate() {
      this.$store.dispatch("method/paginate", this.request);
    },

    select(item) {
      if (this.selectionMap[item._id]) {
        this.$store.commit("datasubjectTransfering/removeMethod", item);
      } else {
        this.$store.commit("datasubjectTransfering/addMethod", item);
      }
    },

    ok() {
      this.$emit("onClosed");
      this.$root.$emit("bv::toggle::collapse", "transfering-method-panel");
    },
  },
};
</script>
